import ApiClient from "../../api-client";
import React, { useEffect, useState } from "react";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { useSelector, useDispatch } from 'react-redux';
import { Button, Form, FormGroup, Input, Label ,InputGroupText,InputGroup} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { validation } from "../../utils/validation";
import "./resetpassword.css";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Importing icons from react-icons
function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  
 
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  useEffect(() => {
    if (!newPasswordError && !confirmPasswordError && email && newPassword && confirmPassword) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [newPasswordError, confirmPasswordError, email, newPassword, confirmPassword]);


  const validatePassword = (password) => {
    if (!password) {
      return "Password is required";
    }else if (!validation.validatePassword(password)) {
      return "Password must be at least 6 characters, include one uppercase letter, one lowercase letter, one number, and one special character.";
    }
    return "";
  };

  const validateConfirmPassword = (password, confirmPassword) => {
    if (!confirmPassword) {
      return "Confirm password is required";
    } else if (password !== confirmPassword) {
      return "Passwords do not match";
    }
    return "";
  };

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
    setNewPasswordError(validatePassword(e.target.value));
    setConfirmPasswordError(validateConfirmPassword(e.target.value, confirmPassword));
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setConfirmPasswordError(validateConfirmPassword(newPassword, e.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newPasswordErr = validatePassword(newPassword);
    const confirmPasswordErr = validateConfirmPassword(newPassword, confirmPassword);
 
    if ( newPasswordErr || confirmPasswordErr) {
      setNewPasswordError(newPasswordErr);
      setConfirmPasswordError(confirmPasswordErr);
      return;
    }
      try {
        const result = await ApiClient.post('api/users/resetpassword', { email, newPassword,confirmPassword })
        if (result.status=== true) {
          toast.success(result.message ,{autoClose:3000})
          navigate("/login");
        } else {
          toast.error("Something went wrong!", { autoClose: 3000 });
        }
      } catch (error) {
        toast.error(error.message, { autoClose: 3000 });
      }
    
  };
  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="mb-10">Welcome</h2>
        <div className="login-logo">Admin</div>
        <Form onClick={handleSubmit}>
          <FormGroup>
            <Label className="label-text" for="email">
              Email
            </Label>
            <Input
              type="email"
              name="email"
              id="email"
              placeholder="Enter your email"
              value={email}
              disabled
              // onChange={(e) => setEmail(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label className="label-text" for="password">
              New Password
            </Label>
            <InputGroup>
                <Input
                  type={showNewPassword ? "text" : "password"}
                  name="newPassword"
                  id="newPassword"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                />
                <InputGroupText onClick={toggleNewPasswordVisibility}>
                  {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                </InputGroupText>
              </InputGroup>
                {newPasswordError && <p  className="error-message">{newPasswordError}</p>}
          </FormGroup>
     
          <FormGroup>
            <Label className="label-text" for="password">
              Confirm Password
            </Label>
            <InputGroup>
                <Input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  id="confirmPassword"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                />
                <InputGroupText onClick={toggleConfirmPasswordVisibility}>
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </InputGroupText>
              </InputGroup>
              {confirmPasswordError && <p  className="error-message">{confirmPasswordError}</p>}

          </FormGroup>
        
          <Button  className="login-button"  disabled={!isFormValid}>
        Reset
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default ResetPassword;
